export const app = {
  version: '1.41.0',
};
